import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ChipComponent } from 'app/common/components/chip/chip.component';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.less'],
  imports: [ChipComponent, RouterModule]
})
export class PortfolioComponent {
  schneiderei = ['Nginx', 'Angular', 'Design'];
  wasner = ['Consulting', 'Confluence'];
  backstage = ['Angular', 'ASP.NET', 'Nginx'];
  tickets = ['Tickera', 'Wordpress', 'E-Commerce']; 
  volkstheater = ['Wordpress', 'Design', 'SEO'];
  demo_backstage = ['ASP.NET', 'Angular', 'Demo']
}